import generalController from "../generalController";
import errorLang from "./shared/error";
import formLang from "./shared/form";
import globalLang from "./shared/global";
import global from "./shared/global";
import { LanguageCode } from "../../types";

interface BilingualText {
  en: string;
  fr: string;
}

interface LanguageData {
  [formType: string]: {
    [fieldName: string]: BilingualText;
  };
}

export const languageController = (function () {
  const langCode: LanguageCode = generalController.detectLanguage();

  const data: LanguageData = {
    nomination: {
      heading: {
        en: 'SUBMISSION FORM ',
        fr: 'FOMULAIRE DE CANDIDATURE '
      },
      submit: {
        en: 'SUBMIT APPLICATION',
        fr: 'SOUMETTRE LA CANDIDATURE',
      },
      yourInformation: {
        en: 'YOUR INFORMATION',
        fr: 'VOS RENSEIGNEMENTS',
      },
      birthdate: {
        en: 'Date of birth: Day / Month / Year',
        fr: 'Date de naissance :  Jour / Mois / Année',
      },
      legendInitiative: {
        en: 'YOUR COMMUNITY CONTRIBUTIONS',
        fr: 'VOS CONTRIBUTIONS COMMUNAUTAIRES',
      },
      ageMajority: {
        en: 'You are under the age of majority. Please provide consent and contact details for your parent or guardian:',
        fr: 'Vous n’avez pas atteint l’âge de la majorité. Veuillez fournir le consentement et les coordonnées de votre parent ou tuteur :',
      },
      shareDetailedInitiative:{
        en:'Share in detail the positive effects that you have accomplished within your community. Use these prompts to help guide your response: What type of contributions do you make within your community? What type of charitable work or organizations are you involved with and why? What is the impact of your efforts within your community? ',
        fr:'Racontez en détail les retombées positives de vos actions au sein de votre communauté. Utilisez ces messages-guides pour vous aider : Quel type de contribution apportez-vous au sein de votre communauté ? Dans quel type d’activité ou d’organisme caritatif vous impliquez-vous ? Quel est l’impact de vos efforts dans votre communauté ?',
      },
      shareHow:{
        en: 'If selected as a Rising Legend, how do you envision the $50,000 being used to generate a positive influence in your community? (350 words max)*',
        fr: 'Si votre candidature est sélectionnée à titre de Jeune personnalité légendaire, comment envisagez-vous d’utiliser les 50 000 $ pour exercer une influence positive dans votre communauté ? (350 mots maximum)*',
      },
      confirmationHeading: {
        en: 'SUBMISSION RECEIVED ',
        fr: 'SOUMISSION REÇUE',
      },
      confirmationSubHeading: {
        en: 'Thank you for your submission. Check back on December 1st when Mazda’s Rising Legends will be announced. ',
        fr: 'Merci d’avoir soumis votre candidature. Revenez le 1er décembre pour connaître les noms des Jeunes personnalités légendaires de Mazda.',
      },
    },
    kmi: {
      heading: {
        en: 'Keep Me Informed',
        fr: 'Tenez-moi au courant'
      },
      subHeading: {
        en: '',
        fr: '',
      },
      submit: {
        en: 'Sign me up',
        fr: 'JE M’ABONNE',
      },
      subscribeLegal: {
        en: global.subscribeLegal.en,
        fr: global.subscribeLegal.fr
      },
      confirmationHeading: {
        en: 'SUCCESS!',
        fr: 'ENVOYÉ AVEC SUCCÈS!',
      },
      confirmationSubHeading: {
        en: 'Thank you for your request, |firstName|.  <p> You are now signed up to receive updates from Mazda. </p>',
        fr: 'Merci pour votre demande |firstName|. <p>Vous êtes maintenant inscrit pour recevoir des mises à jour de Mazda. </p> ',
      },
      confirmationSubmit: {
        en: 'Sign up another email',
        fr: 'Inscrivez-vous avec un autre courriel'
      }
    },
    contact: {
      heading: {
        en: 'THANKS FOR GETTING IN TOUCH ',
        fr: 'MERCI DE NOUS AVOIR CONTACTÉS ',
      },
      subHeading: {
        en: 'We’ll get back to you as soon as possible.',
        fr: 'Nous vous répondrons dès que possible.',
      },
      buttonLabel: {
        en: 'Submit Inquiry',
        fr: 'Soumettre une demande',
      },
      submit: {
        en: 'Submit Inquiry',
        fr: 'Soumettre une demande',
      },
    },
    findDealer: {
      mobileMap: {
        en: 'Map view',
        fr: 'Voir la carte'
      },
      mobileList: {
        en: 'List view',
        fr: 'Voir la liste'
      },
      searchInput: {
        en: 'Preferred Retailer Name',
        fr: 'Nom du détaillant préféré',
      },
      searchSubmit: {
        en: 'Search',
        fr: 'Rechercher',
      },
      useGeolocation: {
        en: 'Use my current location',
        fr: 'Utiliser ma localisation',
      },
      searching: {
        en: 'Searching',
        fr: 'recherche',
      },
      geoLoading: {
        en: 'Retrieving Geolocation',
        fr: 'Géolocalisaton en cours'
      },
      geoDenied: {
        en: 'Permission denied. Please enable location detection.',
        fr: 'Autorisation refusée. Veuillez activer la localisation.'
      },
      geoUnavailable: {
        en: 'Cannot detect position. Please try postal code instead.',
        fr: 'Impossible de détecter votre position. Veuillez essayer en indiquant un code postal.'
      },
      geoTimeout: {
        en: 'Detection timed out. Please try again.',
        fr: 'La détection a été interrompue. Veuillez réessayer.'
      },
      errorNoResults: {
        en: 'No results found, Please try again',
        fr: 'Aucun résultat, veuillez essayer de nouveau'
      },
      availableServices: {
        en: 'Available Services',
        fr: 'Service disponible',
      },
      serviceEV: {
        en: 'Electric Vehicle Retailer',
        fr: 'Concessionnaire de VÉ',
      },
      serviceCreditApplication: {
        en: 'Credit Application',
        fr: 'Demande de crédit',
      },
      serviceLiveChat: {
        en: 'Live Chat',
        fr: 'Clavardage en direct',
      },
      serviceTradeIn: {
        en: 'Trade-in Tool',
        fr: 'Estimation de la valeur de reprise',
      },
      serviceTradeInUrl: {
        en: '/en/shopping/trade-in-estimator/',
        fr: '/fr/shopping/Estimateur-de-la-valeur-dechange/'
      },
      serviceSMS: {
        en: 'SMS',
        fr: 'Message SMS',
      },
      serviceOnlinePurchasing: {
        en: 'Online Purchasing',
        fr: 'Achat en ligne',
      },
      hoursSales: {
        en: 'Sales Hours',
        fr: 'Heures d\'ouverture',
      },
      hoursParts: {
        en: 'Parts Hours',
        fr: 'Pièces',
      },
      hoursService: {
        en: 'Service Hours',
        fr: 'Service',
      },
      bookServiceCta: {
        en: 'SCHEDULE A SERVICE',
        fr: 'RÉSERVER UN ENTRETIEN',
      },
      bookTestDriveCta: {
        en: 'Book a test drive',
        fr: 'RÉSERVER UN ESSAI ROUTIER',
      },
      GetQuoteCta: {
        en: 'Request a quote',
        fr: 'Demande de prix',
      },
      or: {
        en: globalLang.or.en,
        fr: globalLang.or.fr,
      },
      closed: {
        en: 'Closed',
        fr: 'Fermé'
      },
      sendBuildToDealer: {
        en: 'Send build to this retailer',
        fr: 'Send build to this retailer (FR)'
      },
      reserveYours: {
        en: 'Get Local Price',
        fr: 'Obtenir un devis'
      },
      preOrder: {
        en: 'PRE-ORDER NOW',
        fr: 'PRÉCOMMANDER'
      },  
      beforeOpen: {
        en: 'Opens at',
        fr: 'Ouvre à',
      },
      openUntil: {
        en: 'Open now until',
        fr: 'Maintenant ouvert jusqu’à',
      },
      afterOpen: {
        en: 'Opens at',
        fr: 'Ouvre à',
      },
      nextOpenday: {
        en: 'Opens at',
        fr: 'Ouvre à',
      },
      modalServiceTitle : {
        en: "YOU ARE LEAVING MAZDA.CA",
        fr: "VOUS QUITTEZ MAZDA.CA",
      },
      modalServiceContent : {
         en: "By clicking below, you will be redirected to |dealer| to continue your service scheduling.",
         fr: "En cliquant ci-dessous, vous serez redirigé vers |dealer| pour prendre un rendez-vous."
      },
      modalServiceButton : {
        en: "continue to |dealer|",
        fr: "CONTINUER VERS |dealer|"
      },
      award : {
        en: "In recognition of outstanding performance and business results. ",
        fr: "En reconnaissance de performances et de résultats commerciaux exceptionnels."
      },
      instructions : {
        en: "Please enter postal code, search by retailer name or allow location detection.",
        fr: "Veuillez saisir un code postal, rechercher par nom de détaillant ou autoriser la détection de localisation."
      },
      loadMore : {
        en: "Show more retailers",
        fr: "Montrer plus de détaillants"
      },
      preferred_retailer :{
        en: "My Preferred Retailer",
        fr: "Mon détaillant préféré"
      },
      preferred_retailer_off :{
        en: "Set as Preferred Retailer",
        fr: "Choisir comme détaillant préféré"
      },
      preferred_retailer_on :{
        en: "Remove Preferred Retailer",
        fr: "Supprimer le détaillant préféré"
      }
    },
    testDrive: {
      step1Title: {
        en: 'REQUEST A TEST DRIVE',
        fr: 'DEMANDER UN ESSAI ROUTIER'
      },
      step2Subtitle: {
        en: 'Please select a date and time of day you’d like to test drive a Mazda vehicle.',
        fr: 'Veuillez sélectionner la date et l\'heure de la journée qui vous convient pour tester un véhicule Mazda'
      },
      step4Submit: {
        en: 'Book test drive',
        fr: 'Réserver un essai routier'
      },
    },
    getQuote: {
      step1Title: {
        en: 'Get a Quote',
        fr: 'DEMANDER UN PRIX'
      },
      step2Submit: {
        en: 'Get your quote',
        fr: 'DEMANDER UN PRIX'
      },
    },
    reserveYours: {
      step1Title: {
        en: 'Get Local Price',
        fr: 'Obtenez un prix local'
      },
      step2Submit: {
        en: 'Get Local Price',
        fr: 'Obtenir un devis'
      },
    },
    preOrder: {
      step1Title: {
        en: 'PRE-ORDER NOW',
        fr: 'PRÉCOMMANDEZ VOTRE MAZDA'
      },
      step2Submit: {
        en: 'PRE-ORDER NOW',
        fr: 'PRÉCOMMANDER'
      },
    },
    confirmationStep: {
      title: {
        en: 'Thank you for your request',
        fr: 'MERCI DE VOTRE DEMANDE',
      },
      subTitle: {
        en: 'Your retailer will contact you shortly.',
        fr: 'Votre concessionnaire communiquera avec vous sous peu.',
      },
      subTitleRetailer: {
        en: 'We will contact you shortly.',
        fr: 'Nous vous contacterons sous peu.',
      },
    },
    tradeInEstimator: {
      // Step navs
      step1: {
        en: 'Your Current vehicle',
        fr: 'VOTRE VÉHICULE ACTUEL',
      },
      step2: {
        en: 'Your Desired Mazda',
        fr: 'MAZDA DÉSIRÉE',
      },
      step3: {
        en: 'Contact Details',
        fr: 'COORDONNÉES',
      },
      step4: {
        en: 'Find a Retailer',
        fr: 'TROUVER UN DÉTAILLANT',
      },
      // Step 1
      step1Title: {
        en: 'Select your current vehicle',
        fr: 'HOISISSEZ VOTRE VÉHICULE',
      },
      step1Disclaimer: {
        en: 'The value of your vehicle is influenced by the odometer reading, its equipment, and most importantly, the condition of the vehicle. The values presented here may be higher or lower after your vehicle has been evaluated by a professional vehicle appraiser.',
        fr: 'La valeur de votre véhicule est influencée par le relevé du compteur kilométrique, par l’équipement, et surtout, par l’état du véhicule. Les valeurs présentées ici pourraient être supérieures ou moindres après une évaluation de votre véhicule par un estimateur-expert. ',
      },
      retailerTitle:{
        en:'Estimate your trade-in value',
        fr:'ESTIMEZ VOTRE VALEUR DE REPRISE'
      },
      retailerSubTitle:{
        en:'Enter the details for your current vehicle',
        fr:'Entrez les informations sur votre véhicule actuel.'
      },
      retailerButton:{
        en:'Get Value',
        fr:'OBTENIR LA VALEUR'
      },
      // Step 2
      step2Title: {
        en: 'Select your desired mazda',
        fr: 'CHOISISSEZ VOTRE MAZDA DÉSIRÉE ',
      },
      // Step 3
      step3Title: {
        en: 'Please enter your contact details',
        fr: 'VEUILLEZ INSCRIRE VOS COORDONNÉES',
      },
      // Step 4
      step4Title: {
        en: 'FIND YOUR PREFERRED RETAILER',
        fr: 'TROUVEZ VOTRE DÉTAILLANT PRÉFÉRÉ',
      },
      step4Submit: {
        en: 'Get your trade in estimate',
        fr: 'Estimez la valeur de reprise',
      },
      // Ste; 5
      step5Title: {
        en: 'YOUR TRADE-IN VALUE ESTIMATE',
        fr: 'ESTIMATION DE LA VALEUR DE REPRISE',
      },
      step5Title2: {
        en: 'You are interested in',
        fr: 'QUEL VÉHICULE ENVISAGEZ-VOUS ? ',
      },
      step5EstimateCopy1: {
        en: 'Based on your current vehicle',
        fr: 'EN FONCTION DE VOTRE VÉHICULE ACTUEL',
      },
      step5EditDetails: {
        en: 'Edit Details',
        fr: 'Modifiez les détails',
      },
      step5Estimate1: {
        en: 'APPLY THE LOWER ESTIMATED TRADE-IN VALUE TO YOUR',
        fr: 'APPLIQUER LA VALEUR DE REPRISE ESTIMÉE LA PLUS BASSE À LA CONSTRUCTION DE VOTRE',
      },
      step5Estimate2: {
        en: 'BUILD.',
        fr: '.',
      },
      backToBuild: {
        en: 'Back to your build',
        fr: 'RETOUR À VOTRE CONSTRUCTION',
      }
    },
    bookServiceAppointment: {
      // Step navs
      step1: {
        en: 'Vehicle info',
        fr: 'RENSEIGNEMENTS SUR VOTRE VÉHICULE',
      },
      step2: {
        en: 'Service Details',
        fr: 'SERVICE REQUIS',
      },
      step3: {
        en: 'Find a retailer',
        fr: 'TROUVER UN DÉTAILLANT',
      },
      step4: {
        en: 'DATE & TIME',
        fr: 'DATE ET HEURE ',
      },
      step5: {
        en: 'Contact details',
        fr: 'COORDONNÉES',
      },
      // Step 2
      step2Title: {
        en: 'Service Details',
        fr: 'SERVICE REQUIS',
      },
      step2SubTitle: {
        en: 'Tell us what we can do for you. ',
        fr: 'Comment pouvons-nous vous aider ? ',
      },
      // Step 3
      step3Title: {
        en: 'Choose your preferred retailer',
        fr: 'TROUVER LE DÉTAILLANT LE PLUS PRÈS',
      },
      // Step 4
      step4SubTitle: {
        en: 'Please select a date and time of day you’d like to book your vehicle service.',
        fr: 'Veuillez choisir la date et l’heure de votre rendez-vous.',
      },
      // Step 5
      step5Submit: {
        en: 'SCHEDULE A SERVICE',
        fr: 'RÉSERVER UN ENTRETIEN',
      },
      carData: {
        en: 'An error retrieving car data occcured. Please try again later.',
        fr: 'Une erreur s\'est produite lors de la récupération des données. Veuillez réessayer plus tard.'
      },
      // 48 hour notice
      notice: {
        en: 'Please note that appointments for today or tomorrow cannot be booked here. All service bookings require 48-hours notice. If you need an urgent appointment, kindly reach out directly to your nearest Mazda retailer.',
        fr: 'Veuillez noter que les rendez-vous pour aujourd\'hui ou demain ne peuvent pas être pris ici. Toutes les réservations d’entretien nécessitent un préavis de 48 heures. Si vous avez besoin d\'un rendez-vous urgent, veuillez contacter directement votre concessionnaire Mazda le plus proche.',
      },
    },
    evRangeMap: {
      searchCTA: {
        en: 'Show range',
        fr: 'Afficher l’autonomie',
      },
      showRangeLoading: {
        en: 'Loading', // tmp
        fr: 'Chargement', // tmp
      },
    },
    EVBatteryCalculator: {
      charging: {
        en: 'Charging<sup>2</sup> battery up from',
        fr: 'Recharger<sup>2</sup> la batterie de',
      },
      range: {
        en: 'KM RANGE<sup>3</sup> IN',
        fr: ' KM D’AUTONOMIE<sup>3</sup> EN',
      },
    },
    saveBuild: {
      heading: {
        en: 'Save your build',
        fr: 'SAUVEGARDER VOS CHOIX'
      },
      subHeading: {
        en: 'Save time and conveniently save your ideal Mazda now for future reference.',
        fr: 'Conservez la fiche de votre Mazda idéale pour la consulter facilement.',
      },
      submit: {
        en: 'Save my build',
        fr: 'SAUVEGARDER MES CHOIX',
      },
      confirmationHeading: {
        en: 'Your build is saved',
        fr: 'VOS CHOIX ONT ÉTÉ SAUVEGARDÉS',
      },
      confirmationSubHeading: {
        en: 'We emailed you a link so you can review this build later.',
        fr: 'Nous vous avons envoyé par courriel un lien qui vous permet de consulter la fiche de votre Mazda idéale en tout temps.',
      },
      confirmationSubmit: {
        en: 'Close this window',
        fr: 'FERMER LA FENÊTRE'
      }
    },
    shareBuild: {
      heading: {
        en: 'Share your build',
        fr: 'PARTAGER VOS CHOIX'
      },
      subHeading: {
        en: 'Send the URL of your Mazda build via email.',
        fr: 'Envoyez le lien vers votre Mazda idéale à un ami.',
      },
      submit: {
        en: 'Share my build',
        fr: 'PARTAGER MES CHOIX',
      },
      confirmationHeading: {
        en: 'Your build is shared',
        fr: 'VOS CHOIX ONT ÉTÉ SAUVEGARDÉS',
      },
      confirmationSubHeading: {
        en: 'We have sent an email with a link to your build.',
        fr: 'Un courriel avec le lien vers votre Mazda idéale a été envoyé.',
      },
      confirmationSubmit: {
        en: 'Close window',
        fr: 'FERMER LA FENÊTRE'
      },
      byEmail: {
        en: 'By Email',
        fr: 'Par Courriel'
      },
      bySMS: {
        en: 'By SMS',
        fr: 'Par SMS'
      },
    },
    sendBuildToDealer: {
      heading: {
        en: 'Get Local Price',
        fr: 'Obtenez un prix local'
      },
      subHeading: {
        en: 'Send your build to the nearest retailer',
        fr: 'Envoyer mes choix au détaillant le plus près',
      },
      retailerHeading:{
        en: 'Get Local Price',
        fr: 'Obtenez un prix local'
      },
      retailerSubHeading1:{
        en: 'Send your build to',
        fr: 'Envoyez votre construction à'
      },
      retailerSubHeading2:{
        en: 'for an accurate price.',
        fr: 'pour un prix exact.'
      },
      submit: {
        en: 'Get Local Price',
        fr: 'Obtenir un devis'
      },
      confirmationHeading: {
        en: 'Your build was shared with your&nbsp;retailer',
        fr: 'Vos choix ont été<br>transférés au détaillant',
      },
      retailerConfirmationHeading: {
        en: 'Your build was shared with',
        fr: 'Vos choix ont été transférés au détaillant',
      },
      confirmationSubHeading: {
        en: 'A retailer will contact you soon.',
        fr: 'Le détaillant communiquera avec vous sous&nbsp;peu',
      },
      confirmationSubHeadingRetailer:{
        en: 'We will contact you shortly.',
        fr: 'Nous vous contacterons sous peu.'
      },
      confirmationSubmit: {
        en: 'Close this window',
        fr: 'FERMER LA FENÊTRE'
      },
    },
    specCompare: {
      subHeading: {
        en: 'SPECIFICATIONS COMPARISON',
        fr: 'COMPARAISON DES SPÉCIFICATIONS',
      },
      backButton: {
        en: 'Back to',
        fr: 'Retour vers',
      },
      changeTrim: {
        en: 'Change Trim',
        fr: 'Changer de finition',
      },
      downloadSpecs: {
        en: 'Download full specs',
        fr: 'TÉLÉCHARGER TOUTES LES CARACTÉRISTIQUES',
      },
      downloadBrochure: {
        en: 'Download brochure',
        fr: 'TÉLÉCHARGER LA BROCHURE',
      },
      pricePrefix: {
        en: 'Starting at ',
        fr: 'À partir de ',
      },
      trimColumnCTALabel: {
        en: 'Design Yours',
        fr: 'Configurer',
      },
    },
    vehicleAccessories: {
      heading: {
        en: 'Select your vehicle',
        fr: 'SÉLECTIONNEZ LE VÉHICULE',
      },
      accessories: {
        en: 'ACCESSORIES',
        fr: 'ACCESSOIRES',
      },
      continue: {
        en: 'View Accessories',
        fr: 'VOIR LES ACCESSOIRES',
      },
      back: {
        en: 'Select a different vehicle',
        fr: 'Veuillez sélectionner un modèle de véhicule différent',
      },
      categoryAll: {
        en: 'All Accessories',
        fr: 'Tous les accessoires',
      },
      priceSuffix: {
        en: 'with installation',
        fr: 'avec installation',
      },
    },
  };

  return {
    getCopy: function (type: string, name: string): string | undefined {
      try {
        if (type && name && langCode) {
          if (type !== 'global') {
            return data[type][name][langCode];
          } else {
            return globalLang[name][langCode];
          }
        }
      } catch (err) {
        console.log('Error: ' + type + ', ' + name + ', ' + langCode + ' not found in getCopy in languageController');
      }
    },
    getError: function (type: string): string | undefined {
      try {
        if (type && langCode) {
          return errorLang[type][langCode];
        }
      } catch (err) {
        console.log('Error: Error message of ' + type + ', ' + langCode + ' not found in getError in languageController');
      }
    },
    getFormCopy: function (type: string, name: string): string | undefined {
      try {
        if (type && name && langCode) {
          return formLang[type][name][langCode];
        }
      } catch (err) {
        console.log('Error: Form copy of ' + type + ', ' + name + ', ' + langCode + ' not found in getFormCopy in languageController');
      }
    }
  };
})();
